import { createContext } from "react";

const PackageSubscriptionContext = createContext(undefined as any);

export default PackageSubscriptionContext;
